import { ConversationSummarySchema, CreateTagRequest, PartyResponse, SetTagsRequest, SetTagStatusRequest, TagListResponse, TagSummary, UpdateTagRequest, } from '@aeris/contracts';
import { request } from "./client.js";
export const fetchTags = async (scope, status, signal) => {
    const params = new URLSearchParams({ scope });
    if (status !== undefined)
        params.set('status', status);
    return TagListResponse.parse(await request(`/api/v1/tags?${params.toString()}`, { signal })).tags;
};
export const createTag = async (input) => TagSummary.parse(await request('/api/v1/tags', {
    method: 'POST',
    body: CreateTagRequest.parse(input),
}));
export const updateTag = async (id, input) => TagSummary.parse(await request(`/api/v1/tags/${id}`, {
    method: 'PATCH',
    body: UpdateTagRequest.parse(input),
}));
export const setTagStatus = async (id, input) => TagSummary.parse(await request(`/api/v1/tags/${id}/status`, {
    method: 'POST',
    body: SetTagStatusRequest.parse(input),
}));
/** Troca o conjunto INTEIRO de marcadores — ver `SetTagsRequest`. */
export const setPartyTags = async (partyId, tagIds) => PartyResponse.parse(await request(`/api/v1/parties/${partyId}/tags`, {
    method: 'PUT',
    body: SetTagsRequest.parse({ tagIds: [...tagIds] }),
}));
export const setConversationTags = async (conversationId, tagIds) => ConversationSummarySchema.parse(await request(`/api/v1/communication/conversations/${conversationId}/tags`, {
    method: 'PUT',
    body: SetTagsRequest.parse({ tagIds: [...tagIds] }),
}));
//# sourceMappingURL=tags.js.map